import { BASE_API } from 'constants/env';

/**
 * Singleton for keeping and setting the base API domain.
 * Initialized from the environment variable, it can be changed by the config.
 */
class APIBase {
  constructor() {
    this.apiBase = `${BASE_API}/api`;
  }

  setAPIBase(newBase) {
    this.apiBase = `${newBase}/api`;
  }

  getAPIBase() {
    return this.apiBase;
  }
}

const apiBaseInstance = new APIBase();

export const setAPIBase = (newBase) => {
  apiBaseInstance.setAPIBase(newBase);
}

export const getAPIBase = () => {
  return apiBaseInstance.getAPIBase();
}

export default apiBaseInstance;
